import { InjectionToken } from '@angular/core';
import { AutomobilePlatformApiService } from '../automobile-platform-api.service.ts.service';

export const HTTP_AUTOMOBILE_PLATFORM_SERVICE = new InjectionToken(
  'AutomobilePlatformApiService'
);

export const AUTOMOBILE_PLATFORM_API_PROVIDER = {
  provide: HTTP_AUTOMOBILE_PLATFORM_SERVICE,
  useClass: AutomobilePlatformApiService,
};